/*
 * @Author: 张丛 nhsoft.zhangc
 * @LastEditors: 张丛 nhsoft.zhangc
 * @Date: 2024-04-15 16:05:45
 * @LastEditTime: 2024-04-16 13:45:34
 * @Description: 新增或编辑商品成本卡
 */

import type {
  IProductCostCardModel,
  IProductCostCardStore,
} from '@monorepo/types/document/costCard/costCard.types';
import { tableUpdate } from '@monorepo/utils';

const initState: IProductCostCardStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    location_id: '',
    offset: 0,
    limit: 50,
  },
};

const ProductCostCardStore: IProductCostCardModel = {
  namespace: 'productCostCardStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return { ...state, tableList };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default ProductCostCardStore;
